import { css, cva } from '@repo/pandacss/css';

/** FlexGrid column spacing var — must match FlexGrid container and driversGridStyles. */
const COLUMN_GAP = 'var(--FlexGrid-columnSpacing)';

export const DEFAULT_DRIVER_LAYOUT_VARIANTS = {
  mobileColumns: '1',
  desktopColumns: '1',
} as const;

/**
 * Atomic recipe for per-driver flex-wrap sizing.
 * All calc() literals are static so Panda can extract CSS at build time.
 */
export const driverFlexColumns = cva({
  variants: {
    mobileColumns: {
      '1': {
        flexBasis: '[100%]',
        width: '[100%]',
      },
      '2': {
        flexBasis: `[calc((100% - (${COLUMN_GAP} * 1)) / 2)]`,
        width: 'auto',
      },
      '3': {
        flexBasis: `[calc((100% - (${COLUMN_GAP} * 2)) / 3)]`,
        width: 'auto',
      },
      '4': {
        flexBasis: `[calc((100% - (${COLUMN_GAP} * 3)) / 4)]`,
        width: 'auto',
      },
      '5': {
        flexBasis: `[calc((100% - (${COLUMN_GAP} * 4)) / 5)]`,
        width: 'auto',
      },
      '6': {
        flexBasis: `[calc((100% - (${COLUMN_GAP} * 5)) / 6)]`,
        width: 'auto',
      },
      '7': {
        flexBasis: `[calc((100% - (${COLUMN_GAP} * 6)) / 7)]`,
        width: 'auto',
      },
    },
    desktopColumns: {
      '1': {
        _pcMd: {
          flexBasis: '[100%]',
        },
      },
      '2': {
        _pcMd: {
          flexBasis: `[calc((100% - (${COLUMN_GAP} * 1)) / 2)]`,
        },
      },
      '3': {
        _pcMd: {
          flexBasis: `[calc((100% - (${COLUMN_GAP} * 2)) / 3)]`,
        },
      },
      '4': {
        _pcMd: {
          flexBasis: `[calc((100% - (${COLUMN_GAP} * 3)) / 4)]`,
        },
      },
    },
  },
  defaultVariants: DEFAULT_DRIVER_LAYOUT_VARIANTS,
  compoundVariants: [
    {
      mobileColumns: '1',
      desktopColumns: '2',
      css: { _pcMd: { width: 'auto' } },
    },
    {
      mobileColumns: '1',
      desktopColumns: '3',
      css: { _pcMd: { width: 'auto' } },
    },
    {
      mobileColumns: '1',
      desktopColumns: '4',
      css: { _pcMd: { width: 'auto' } },
    },
  ],
});

const driversGridPseudoBase = css.raw({
  content: '""',
  position: 'absolute',
  left: '[calc(var(--FlexGrid-columnSpacing)/-2)]',
  top: '[-1px]',
  backgroundColor: 'grey.200',
});

export const driversGridStyles = css.raw({
  overflow: 'hidden',
  mt: '[0.7rem]',
  mb: '0',
  '& > div': {
    pt: '2',
    pb: '[13px]',
    flexGrow: 1,
    position: 'relative',
    _before: {
      ...driversGridPseudoBase,
      height: '[1px]',
      width: '[calc(100% + var(--FlexGrid-columnSpacing))]',
    },
    _after: {
      ...driversGridPseudoBase,
      width: '[1px]',
      height: '[calc(100% + var(--FlexGrid-rowSpacing))]',
    },
  },
  _pcMd: {
    mt: '0',
    mb: '3',
    px: '[calc(var(--FlexGrid-columnSpacing)/2 - 1px)]',
  },
});
